/** Project-lifecycle product events (spec 68 §6.6.3, spec 67). */
import { z } from 'zod';
import { DEFAULT_SCHEMA_VER, id } from './_shared.js';

export const projectEvents = {
  'project.created': {
    schema: z.object({ account_id: id, project_id: id, is_default: z.boolean() }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'project.deleted': {
    schema: z.object({ account_id: id, project_id: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'project.default_model_set': {
    schema: z.object({ account_id: id, project_id: id, model_slug: id }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'project.egress_set': {
    schema: z.object({ account_id: id, project_id: id, egress_mode: z.string().min(1) }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'project.connector_added': {
    schema: z.object({ account_id: id, project_id: id, connector_kind: z.string().min(1) }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'project.connector_removed': {
    schema: z.object({ account_id: id, project_id: id, connector_kind: z.string().min(1) }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'project.connector_refreshed': {
    schema: z.object({
      account_id: id,
      project_id: id,
      connector_kind: z.string().min(1),
      outcome: z.string().min(1),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
  'project.file_uploaded': {
    schema: z.object({
      account_id: id,
      project_id: id,
      file_count: z.number().int().nonnegative().optional(),
      total_bytes: z.number().int().nonnegative().optional(),
    }),
    schemaVer: DEFAULT_SCHEMA_VER,
  },
} as const;
